/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  OptOutGroupWithStatusDTO,
  OptOutGroupWithStatusDTOOptional,
  OptOutGroupWithStatusDTOMetaI,
  OptOutGroupWithStatusDTOTrackedI,
} from "./opt-out-group-with-status-dto";
import {
  OptOutGroupWithStatusDTOTracked,
  OptOutGroupWithStatusDTOMeta,
} from "./opt-out-group-with-status-dto";

/**
 *
 * @export
 * @interface OptOutStatusResponseDTO
 */
export interface OptOutStatusResponseDTOOptional {
  /**
   *
   * @type {Array<OptOutGroupWithStatusDTO>}
   * @memberof OptOutStatusResponseDTO
   */
  groups?: OptOutGroupWithStatusDTOOptional[];
}

export interface OptOutStatusResponseDTO extends OptOutStatusResponseDTOOptional {
  /**
   *
   * @type {Array<OptOutGroupWithStatusDTO>}
   * @memberof OptOutStatusResponseDTO
   */
  groups: OptOutGroupWithStatusDTO[];
}

export interface OptOutStatusResponseDTOTrackedI {
  /**
   *
   * @type {Array<OptOutGroupWithStatusDTO>}
   * @memberof OptOutStatusResponseDTO
   */
  groups?: OptOutGroupWithStatusDTOTrackedI[];
  groupsIsSet: boolean;
}

transformDatesMap.set(
  "OptOutStatusResponseDTO",
  function (model: OptOutStatusResponseDTO) {
    const transformDatesgroups = transformDatesMap.get(
      "OptOutGroupWithStatusDTO",
    );
    if (transformDatesgroups) {
      model.groups?.forEach((sub) => {
        transformDatesgroups(sub);
      });
    }
  },
);

export type OptOutStatusResponseDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  groups: PropertyMeta<OptOutGroupWithStatusDTOMetaI>;
}>;

export var OptOutStatusResponseDTOMeta: OptOutStatusResponseDTOMetaI =
  {} as OptOutStatusResponseDTOMetaI;
OptOutStatusResponseDTOMeta = typeMeta("OptOutStatusResponseDTO", {
  groups: propertyMeta(
    "groups",
    true,
    true,
    false,
    OptOutGroupWithStatusDTOMeta,
  ),
});

const metaI = OptOutStatusResponseDTOMeta;

registerMeta(() => {});

export class OptOutStatusResponseDTOTracked implements OptOutStatusResponseDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  groups__I?: OptOutGroupWithStatusDTOTracked[] = undefined;
  groupsIsSet: boolean = false;
  set groups(v: undefined | OptOutGroupWithStatusDTOTracked[]) {
    if (v !== undefined) {
      this.groups__I = v;
      this.groupsIsSet = true;
    } else {
      this.groups__I = v || undefined;
      this.groupsIsSet = true;
    }
    this.changeTracker = true;
  }
  get groups() {
    return this.groups__I;
  }
  constructor(
    config?: OptOutStatusResponseDTOOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.groups?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: OptOutStatusResponseDTOOptional,
    options?: AssignOptions,
  ): OptOutStatusResponseDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.groups && this.groupsApplyFilter(optionsRequired.filter)) {
      this.groups = config.groups?.map(
        (a) => new OptOutGroupWithStatusDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.groupsIsSet = false;
      else this.groupsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): OptOutStatusResponseDTOTrackedI {
    const cloned = {} as OptOutStatusResponseDTOTrackedI;
    if (
      this.groupsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.groupsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.groupsIsSet = true;
      cloned.groups = this.groups
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.groupsIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): OptOutStatusResponseDTOTrackedI {
    if (!this.groupsApplyFilter(filter)) this.groupsIsSet = false;

    this.groups?.forEach((a) => a.unassignAll(filter));
    return this;
  }
  groupsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OptOutStatusResponseDTOMeta.groups,
      OptOutStatusResponseDTOMeta,
      this.groups,
      this,
    );
  }
  groupsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.groupsIsSet && this.groupsApplyFilter(filter)) return true;

    return this.groups?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.groupsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
